import React from 'react';
import { Search, ShieldAlert, FileText, Code2, AlertTriangle, CheckCircle2 } from 'lucide-react';
import './SecurityCompliance.css';

const VulnerabilityScanning = () => {
  return (
    <div className="security-page">
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-copy">
            <div className="status-badge">
              <Search size={14} /> Scanning Core... 85%
            </div>
            <h1>Automated Vulnerability Scanning & Pentesting</h1>
            <p>
              Find the holes in your defense before hackers do. Our automated 
              security audits provide deep insights into your infrastructure's health.
            </p>
            <div className="hero-actions">
              <a className="button primary" href="#contact">Run Free Scan</a>
              <a className="button secondary" href="#reports">Sample Reports</a>
            </div>
          </div>
          <div className="hero-panel">
            <div className="panel-card panel-glow">
              <AlertTriangle className="icon" size={48} />
              <h3>Critical Mitigation</h3>
              <p>Identify and patch CVEs (Common Vulnerabilities and Exposures) in real-time.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <span className="eyebrow">Defense Audit</span>
          <h2>Proactive security intelligence.</h2>
          <p>We combine automated scanning tools with manual expert penetration testing to give you a 360-degree view of your risks.</p>
        </div>

        <div className="security-grid">
          <div className="security-card">
            <div className="sec-icon"><Code2 size={24} /></div>
            <h3>SAST & DAST</h3>
            <p>Static and Dynamic Application Security Testing to find bugs in code and runtime environments.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><ShieldAlert size={24} /></div>
            <h3>Network Audit</h3>
            <p>Port scanning and service mapping to ensure no unnecessary entry points are left exposed.</p>
          </div>
          <div className="security-card">
            <div className="sec-icon"><FileText size={24} /></div>
            <h3>Compliance Scanning</h3>
            <p>Ensure your infrastructure meets HIPAA, PCI-DSS, and GDPR security requirements.</p>
          </div>
        </div>
      </section>

      <section className="section bg-glass" id="reports">
        <div className="feature-block">
          <div className="solution-copy">
            <h3>Detailed Remediation Roadmap</h3>
            <p>
              We do not just find problems; we give you the exact steps, code 
              snippets, and configuration changes needed to fix them.
            </p>
            <div className="checker-grid">
              <div className="check-item"><CheckCircle2 size={16} /> Severity Scoring</div>
              <div className="check-item"><CheckCircle2 size={16} /> Patch Instructions</div>
              <div className="check-item"><CheckCircle2 size={16} /> Executive Summary</div>
              <div className="check-item"><CheckCircle2 size={16} /> Re-scan Validation</div>
            </div>
          </div>
          <div className="encryption-visual">
             <div className="panel-card panel-gradient">
                <FileText size={64} className="icon" />
                <p>PDF Generated with 0 Critical Risks remaining.</p>
             </div>
          </div>
        </div>
      </section>

      <div className="metrics-grid" style={{maxWidth: '1240px', margin: '0 auto 80px'}}>
        <div className="metric-item">
          <strong>10k+</strong>
          <span>Vulnerability Checks</span>
        </div>
        <div className="metric-item">
          <strong>Real-time</strong>
          <span>Monitoring</span>
        </div>
        <div className="metric-item">
          <strong>95/100</strong>
          <span>Avg Security Score</span>
        </div>
        <div className="metric-item">
          <strong>Weekly</strong>
          <span>Deep Reports</span>
        </div>
      </div>

      <section className="cta-section">
        <div className="cta-content">
          <h2>When was your last security audit?</h2>
          <p>Don't wait for a breach. Start your professional vulnerability scan today.</p>
          <a className="button primary" href="#contact">Schedule Pentest</a>
        </div>
      </section>
    </div>
  );
};

export default VulnerabilityScanning;
